import React from "react";
import { Icon } from "@vitalsource/vstui";

const Highlighter = ({ fill }) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={22}
    height={22}
    viewBox="0 0 22 19"
    version="1.1"
  >
    <defs>
      <polygon
        id="path-1"
        points="21.2443 0.5 0.000293461374 0.5 0.000293461374 19.5004 21.2443 19.5004 21.2443 0.5"
      />
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(0.000000, -1.000000)" id="highlighter_icon">
        <g>
          <g transform="translate(0.000000, 0.500000)">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1" />
            </mask>
            <g />
            <path
              d="M17.1643,2.9474 C17.6123,2.4994 18.3443,2.4974 18.7953,2.9484 C19.0123,3.1654 19.1333,3.4554 19.1333,3.7624 C19.1333,4.0714 19.0123,4.3604 18.7953,4.5784 L9.0893,14.2854 L7.4573,12.6544 L17.1643,2.9474 Z M20.2873,6.0714 C20.9043,5.4544 21.2443,4.6344 21.2443,3.7624 C21.2443,2.8904 20.9043,2.0704 20.2873,1.4544 C19.0153,0.1814 16.9433,0.1814 15.6713,1.4544 L4.4723,12.6544 L9.0893,17.2704 L20.2873,6.0714 Z M0.3663,17.7784 L3.4263,14.4824 C3.4683,14.4404 3.5373,14.4414 3.5773,14.4854 L6.9713,17.9524 C7.0013,17.9854 6.9993,18.0364 6.9663,18.0674 L5.4453,19.0734 C5.0553,19.3504 4.5893,19.5004 4.1103,19.5004 L1.1823,19.5004 C0.1033,19.5004 -0.3937,18.5454 0.3663,17.7784 L0.3663,17.7784 Z"
              fill={fill}
              mask="url(#mask-2)"
            />
          </g>
        </g>
      </g>
    </g>
  </Icon>
);

export default Highlighter;
